import React, { useState, useEffect } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import moment from "moment";
import $ from "jquery";
import "daterangepicker/daterangepicker.css";
import "daterangepicker";
import { CSVLink } from "react-csv";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const DeletedUsers = () => {
    const [startDate, setStartDate] = useState(moment("2021-01-01").format("YYYY-MM-DD"));
    const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
    const [district, setDistrict] = useState("all");
    const [type, setType] = useState("all");
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [userDetails, setUserDetails] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
                      const [expandedPlanIndex, setExpandedPlanIndex] = useState(null);
    

    useEffect(() => {
        document.title = 'Deleted Users - Calendar Services';

        // Initialize the date range picker
        $("#kt_daterangepicker_4").daterangepicker(
            {
                startDate: moment("2021-01-01"), // Set the default start date
                endDate: moment(),
                ranges: {
                    Today: [moment(), moment()],
                    Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
                    "Last 7 Days": [moment().subtract(6, "days"), moment()],
                    "Last 30 Days": [moment().subtract(29, "days"), moment()],
                    "This Month": [moment().startOf("month"), moment().endOf("month")],
                    "Last Month": [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")],
                },
            },
            (start, end) => {
                setStartDate(start.format("YYYY-MM-DD"));
                setEndDate(end.format("YYYY-MM-DD"));
                $("#kt_daterangepicker_4").html(`${start.format("MMMM D, YYYY")} - ${end.format("MMMM D, YYYY")}`);
            }
        );

        // Set initial display value
        $("#kt_daterangepicker_4").html(
            `${moment("2021-01-01").format("MMMM D, YYYY")} - ${moment().format("MMMM D, YYYY")}`
        );
    }, []);

    // Fetch data automatically when startDate, endDate, district, or type changes
    useEffect(() => {
        fetchData();
    }, [startDate, endDate, district, type]);

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await axios.post(`${API_BASE_URL}/deleted_users`, { startDate, endDate, district, type });
            setData(response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleReactivation = async (userid) => {
        if (window.confirm("Are you sure you want to reactivate this user?")) {
            try {
                const response = await axios.post(`${API_BASE_URL}/reactivate_user`, { userid });
                alert(response.data.message);
                fetchData(); // Refresh the table after reactivation
            } catch (error) {
                console.error("Error reactivating user:", error);
                alert("Failed to reactivate user.");
            }
        }
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setUserDetails(null);
    };


    const handlePlanClick = (index) => {
        setExpandedPlanIndex(expandedPlanIndex === index ? null : index);
      };

    const handleViewDetails = async (row) => {
        setLoading(true);
        try {
            const payload = { 
                name: row.name, 
                type: row.type, 
                mobileNo: row.mobileno 
            };
    
            const response = await axios.post(`${API_BASE_URL}/registered_users/details_userid_new`, payload);
    
            setUserDetails(response.data);
            setIsModalOpen(true);
        } catch (error) {
            console.error("Error fetching user details:", error);
            alert("Failed to fetch user details.");
        } finally {
            setLoading(false);
        }
    };

    const columns = [
        { name: "SlNo", selector: (row, index) => index + 1, sortable: true },
        {
            name: "Actions",
            cell: (row) => (
                <>
                    <button
                        onClick={() => handleViewDetails(row)}
                        className="btn btn-warning bg-red-200"
                    >
                        View Details
                    </button>
                </>
            ),
        },
        {
            name: "Actions",
            cell: (row) => (
                <>
                    <button 
                        className="bg-green-500 text-white px-2 py-2 rounded" 
                        onClick={() => handleReactivation(row.id)}
                    >
                        Activate
                    </button>
                </>
            ),
        },
        { name: "Name", selector: (row) => row.name, sortable: true },
        { name: "Mobile No", selector: (row) => row.mobileno, sortable: true },
        { name: "Type", selector: (row) => row.type, sortable: true },
        { name: "District", selector: (row) => row.district, sortable: true },
        { name: "City", selector: (row) => row.city, sortable: true },
        // { name: "Plan Name", selector: (row) => row.planname, sortable: true },
        { name: "Registration Date", selector: (row) => row.registration_date, sortable: true },
    ];

    return (
        <div className="max-w-6xl mx-auto mt-8 bg-white p-6 rounded shadow">
            <h2 className="text-2xl font-bold mb-6 text-center">Deleted Users</h2>
            <div className="mb-4 flex gap-4 items-center justify-center">
                <div id="kt_daterangepicker_4" className="border px-4 py-2 cursor-pointer">
                    {`${moment(startDate).format("MMMM D, YYYY")} - ${moment(endDate).format("MMMM D, YYYY")}`}
                </div>
                <select id="district" value={district} onChange={(e) => setDistrict(e.target.value)} className="border p-2 rounded">
                    <option value="all">மாவட்டத்தை தேர்வு செய்க</option>
                    <option value="அரியலூர்">அரியலூர்</option>
                    <option value="இராமநாதபுரம்">இராமநாதபுரம்</option>
                    <option value="ஈரோடு">ஈரோடு</option>
                    <option value="கடலூர்">கடலூர்</option>
                    <option value="கன்னியாகுமரி">கன்னியாகுமரி</option>
                    <option value="கரூர்">கரூர்</option>
                    <option value="கள்ளக்குறிச்சி">கள்ளக்குறிச்சி</option>
                    <option value="காஞ்சிபுரம்">காஞ்சிபுரம்</option>
                    <option value="காரைக்கால்">காரைக்கால்</option>
                    <option value="கிருஷ்ணகிரி">கிருஷ்ணகிரி</option>
                    <option value="கோயம்புத்தூர்">கோயம்புத்தூர்</option>
                    <option value="சிவகங்கை">சிவகங்கை</option>
                    <option value="செங்கல்பட்டு">செங்கல்பட்டு</option>
                    <option value="சென்னை">சென்னை</option>
                    <option value="சேலம்">சேலம்</option>
                    <option value="தஞ்சாவூர்">தஞ்சாவூர்</option>
                    <option value="தர்மபுரி">தர்மபுரி</option>
                    <option value="திண்டுக்கல்">திண்டுக்கல்</option>
                    <option value="திருச்சிராப்பள்ளி">திருச்சிராப்பள்ளி</option>
                    <option value="திருநெல்வேலி">திருநெல்வேலி</option>
                    <option value="திருப்பத்தூர்">திருப்பத்தூர்</option>
                    <option value="திருப்பூர்">திருப்பூர்</option>
                    <option value="திருவண்ணாமலை">திருவண்ணாமலை</option>
                    <option value="திருவள்ளூர்">திருவள்ளூர்</option>
                    <option value="திருவாரூர்">திருவாரூர்</option>
                    <option value="தூத்துக்குடி">தூத்துக்குடி</option>
                    <option value="தென்காசி">தென்காசி</option>
                    <option value="தேனி">தேனி</option>
                    <option value="நாகப்பட்டினம்">நாகப்பட்டினம்</option>
                    <option value="நாமக்கல்">நாமக்கல்</option>
                    <option value="நீலகிரி">நீலகிரி</option>
                    <option value="புதுக்கோட்டை">புதுக்கோட்டை</option>
                    <option value="புதுச்சேரி">புதுச்சேரி</option>
                    <option value="பெரம்பலூர்">பெரம்பலூர்</option>
                    <option value="மதுரை">மதுரை</option>
                    <option value="மயிலாடுதுறை">மயிலாடுதுறை</option>
                    <option value="மஹி">மஹி</option>
                    <option value="யானம்">யானம்</option>
                    <option value="ராணிப்பேட்டை">ராணிப்பேட்டை</option>
                    <option value="விருதுநகர்">விருதுநகர்</option>
                    <option value="விழுப்புரம்">விழுப்புரம்</option>
                    <option value="வேலூர்">வேலூர்</option>
                </select>
                <select id="type" value={type} onChange={(e) => setType(e.target.value)} className="border p-2 rounded">
                    <option value="all">வகையை தேர்வு செய்க</option>
                    <option value="வாஸ்து நிபுணர்">வாஸ்து நிபுணர்</option>
                    <option value="மற்ற ஆன்மிக சேவைகள்">மற்ற ஆன்மிக சேவைகள்</option>
                    <option value="ஜோதிடர்">ஜோதிடர்</option>
                    <option value="ஐயர்">ஐயர்</option>
                    <option value="எண்கணிதம்">எண்கணிதம்</option>
                    <option value="அலங்காரம் செய்பவர்others">அலங்காரம் செய்பவர்others</option>
                    <option value="சிற்பி / ஸ்தபதி- others">சிற்பி / ஸ்தபதி- others</option>
                    <option value="others">others</option>
                    <option value="ஆன்மீக சொற்பொழிவாளர்- others">ஆன்மீக சொற்பொழிவாளர்- others</option>
                    <option value="விபூதி தயாரிப்பவர்- others">விபூதி தயாரிப்பவர்- others</option>
                    <option value="சிர்பி-others">சிர்பி-others</option>
                    <option value="திருவிழா அலங்காரம் செய்பவர்- others">திருவிழா அலங்காரம் செய்பவர்- others</option>
                </select>
            </div>
            <div className="flex justify-end mb-4">
                <CSVLink data={data} headers={[{ label: "Name", key: "name" }, { label: "Mobile", key: "mobileno" }]} filename="deleted_users.csv" className="bg-green-500 text-white px-4 py-2 rounded">Export</CSVLink>
            </div>
           
            {loading ? <p className="text-center">Loading...</p> : <DataTable columns={columns} data={data} pagination className="mt-4" />}
            {isModalOpen && userDetails && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
                    <div
                        className="bg-white p-6 rounded-lg max-w-4xl w-full overflow-y-auto"
                        style={{ maxHeight: "80vh" }}
                    >
                        <h3 className="text-xl font-bold mb-4 text-center text-blue-700">User Details</h3>
                        <div className="grid grid-cols-2 gap-4">
                            <p><strong>Name:</strong> {userDetails.name}</p>
                            <p><strong>Mobile No:</strong> <span style={{ color: "green" }}>{userDetails.mobileNo}</span></p>
                            <p><strong>Gender:</strong> {userDetails.gender || "-"}</p>
                            <p><strong>Type:</strong> {userDetails.type}</p>
                            <p><strong>Category:</strong> {userDetails.category || "-"}</p>
                            <p><strong>District:</strong> {userDetails.district}</p>
                            <p><strong>City:</strong> {userDetails.city}</p>
                            <p><strong>Education:</strong> {userDetails.education}</p>
                            <p><strong>Experience:</strong> {userDetails.experience} years</p>
                            <p><strong>Address:</strong> {userDetails.address || "-"}</p>
                            {/* <p><strong>E-mail:</strong> {userDetails.email || "-"}</p> */}
                            <p><strong>Other Details:</strong> {userDetails.other_details || "-"}</p>
                            <p><strong>Web Link:</strong> <a href={userDetails.webLink} target="_blank" rel="noopener noreferrer">{userDetails.webLink}</a></p>
                            <p><strong>YouTube Link:</strong> <a href={userDetails.youtubeLink} target="_blank" rel="noopener noreferrer">{userDetails.youtubeLink}</a></p>
                            <p><strong>Facebook Link:</strong> <a href={userDetails.facebookLink} target="_blank" rel="noopener noreferrer">{userDetails.facebookLink}</a></p>
                        </div>
                        <div className="mt-4 grid grid-cols-2 gap-4">
                            <div>
                                <strong>Image 1:</strong>
                                {userDetails.image1 && (
                                    <img
                                    src={`${API_BASE_URL}/${userDetails.image1}`} 
                                    alt="Image 1"
                                        className="w-40 h-40 object-cover"
                                    />
                                )}
                            </div>
                            <div>
                                <strong>Image 2:</strong>
                                {userDetails.image2 && (
                                    <img
                                    src={`${API_BASE_URL}/${userDetails.image2}`} 
                                    alt="Image 2"
                                        className="w-40 h-40 object-cover"
                                    />
                                )}
                            </div>
                            <div>
                                <strong>ID proof</strong>
                                {userDetails.idproof && (
                                    <img
                                        src={userDetails.idproof}
                                        alt="Image 2"
                                        className="w-40 h-40 object-cover"
                                    />
                                )}
                            </div>
                            <div>
                                <strong>Address Proof</strong>
                                {userDetails.addressproof && (
                                    <img
                                        src={userDetails.addressproof}
                                        alt="Image 2"
                                        className="w-40 h-40 object-cover"
                                    />
                                )}
                            </div>
                            <div>
                                <strong>Other Proof</strong>
                                {userDetails.otherproof && (
                                    <img
                                        src={userDetails.otherproof}
                                        alt="Image 2"
                                        className="w-40 h-40 object-cover"
                                    />
                                )}
                            </div>
                        </div>
                        <div className="mt-4">
      <h2 className="text-xl font-bold mb-4">Plans</h2>
      {userDetails.plans && userDetails.plans.length > 0 ? (
        userDetails.plans.map((plan, index) => (
          <div
            key={index}
            onClick={() => handlePlanClick(index)} // Click handler on the card
            className={`border border-gray-300 rounded-lg shadow-lg p-4 mb-4 cursor-pointer ${
              expandedPlanIndex === index ? "bg-gray-100" : "bg-white"
            }`} // Styling for active and inactive cards
          >
            {/* Card Header */}
            <div className="flex justify-between items-center">
              <h3 className="text-lg font-semibold">{plan.name}</h3>
              <button
  className="text-blue-500 underline"
  onClick={(e) => {
    e.stopPropagation(); // Prevent card click from triggering
    const userId = plan.userId || userDetails.id; // Ensure userId is correctly assigned
    if (userId) {
      window.open(`${API_BASE_URL}/generate_invoice/${userId}`, "_blank"); // Open in a new tab
    } else {
      alert("User ID is missing. Unable to generate invoice.");
    }
  }}
>
  Invoice PDF
</button>
            </div>

            {/* Card Details */}
            {expandedPlanIndex === index && (
              <div className="mt-4">
                <div className="flex justify-between">
                  <p>
                    <strong>Start Date:</strong> {plan.startDate}
                  </p>
                  <p>
                    <strong>End Date:</strong> {plan.endDate}
                  </p>
                </div>
                <p className="mt-2">
                  <strong>Invoice Number:</strong> {plan.invoiceNumber}
                </p>
                <div className="mt-4 border-t border-gray-200 pt-4">
                  <p>
                    <strong>Actual Amount:</strong> ₹{plan.actualAmount} /-
                  </p>
                  <p>
                    <strong>GST Amount (18%):</strong> ₹{plan.gstAmount} /-
                  </p>
                  <p>
                    <strong>Total Amount:</strong> ₹{plan.totalAmount} /-
                  </p>
                </div>
              </div>
            )}
          </div>
        ))
      ) : (
        <p>No plans available</p>
      )}
    </div>
  
                        <div className="mt-6 text-center">
                            <button onClick={closeModal} className="btn btn-secondary text-red-500">Close</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DeletedUsers;